import React, { useState } from 'react';
import {
    Box,
    Button,
    Paper,
    Typography,
    CircularProgress,
} from '@mui/material';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { axios_tenant } from "../../../axios";
import { toast } from 'react-toastify';

export default function Export() {
    const [downloading, setDownloading] = useState(false);

    const handleDownload = async () => {
        setDownloading(true);
        try {
            const res = await axios_tenant.get('/file-number-generator/export', {
                responseType: 'blob'
            });
            // Create a link to download the file
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'system_generated_family_numbers.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {
            toast.error('Failed to download data');
        } finally {
            setDownloading(false);
        }
    };

    // TODO: Replace with real admin check
    const isAdmin = localStorage.getItem("TENANT_ROLE") == "admin";

    if (!isAdmin) {
        return <Typography>You do not have access to this page.</Typography>;
    }

    return (

                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<FileDownloadIcon />}
                        onClick={handleDownload}
                        disabled={downloading}
                        sx={{ px: 3, py: 1.2, fontWeight: 500 }}
                    >
                        {downloading ? <CircularProgress size={22} color="inherit" /> : "Download the System Generated Numbers"}
                    </Button>
                </Box>
            
    );
}